import cachedHttpClient from '../cached-http-client';
import { buildQueryString } from './query-builder';
import { ApiResponse } from '../../types/responses/api-response';
import {
  AIRecommendation,
  IRecommendationEngine,
  RecommendationCategory,
  RecommendationPriority,
} from '../../types/analytics';
import { ANALYTICS_RECOMMENDATIONS } from '../../constants/api-endpoints';

const BASE_URL = ANALYTICS_RECOMMENDATIONS;

export interface RecommendationFilters {
  engineId?: string;
  category?: RecommendationCategory | string;
  priority?: RecommendationPriority | string;
  search?: string;
  limit?: number;
  offset?: number;
  includeExplainers?: boolean;
  userId?: string;
}

export interface RecommendationFeedbackPayload {
  feedback: 'positive' | 'negative';
  comment?: string;
  metadata?: Record<string, any>;
}

export interface ApplyRecommendationPayload {
  context?: Record<string, any>;
  parameters?: Record<string, any>;
}

export const analyticsRecommendationsApi = {
  async getRecommendations(
    filters: RecommendationFilters = {}
  ): Promise<ApiResponse<{ recommendations: AIRecommendation[] }>> {
    const response = await cachedHttpClient.get<ApiResponse<{ recommendations: AIRecommendation[] }>>(
      `${BASE_URL}${buildQueryString(filters)}`
    );

    return response.data;
  },

  async getRecommendationEngines(): Promise<ApiResponse<{ engines: IRecommendationEngine[] }>> {
    const response = await cachedHttpClient.get<ApiResponse<{ engines: IRecommendationEngine[] }>>(
      `${BASE_URL}/engines`
    );

    return response.data;
  },

  async sendRecommendationFeedback(
    recommendationId: string,
    payload: RecommendationFeedbackPayload
  ): Promise<ApiResponse<{ success: boolean }>> {
    const response = await cachedHttpClient.post<ApiResponse<{ success: boolean }>>(
      `${BASE_URL}/${recommendationId}/feedback`,
      payload
    );

    return response.data;
  },

  async applyRecommendation(
    recommendationId: string,
    payload: ApplyRecommendationPayload = {}
  ): Promise<ApiResponse<{ success: boolean; jobId?: string }>> {
    const response = await cachedHttpClient.post<ApiResponse<{ success: boolean; jobId?: string }>>(
      `${BASE_URL}/${recommendationId}/apply`,
      payload
    );

    return response.data;
  },
};

export default analyticsRecommendationsApi;

